import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { replaceKoiError } from './replaceKoiError';

export interface IAbsenceAddEditValidated {
    endDate: string;
    startDate: string;
}

export const absenceAddEditSchema: ISchemaContainer<IAbsenceAddEditValidated> = {
    schema: Koi.object({
        endDate: Koi.koi().date().endDate(),
        startDate: Koi.koi().date(),
    }).options({ convert: false, presence: 'required' }),
};

export function absenceAddEditEndDateTodayOrInFutureSchema(date: Date) {
    return {
        schema: Koi.object({
            endDate: Koi.date()
                .min(date)
                .required()
                .error((errors) => replaceKoiError(errors, 'date.min', 'datePeriodPast')),
        }).options({ convert: false, presence: 'required' }),
    };
}
